/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const launchChecklistDemoContent = [
  { type: 'heading', level: 1, text: 'Launch checklist — Mission Control' },
  { type: 'heading', level: 3, text: 'Must ship' },
  {
    type: 'checklist',
    items: [
      { text: 'Notes search + new note row', checked: true },
      { text: 'Meeting @time header behavior', checked: true },
      { text: 'Sidebar selection sync', checked: true },
    ],
  },
  { type: 'heading', level: 3, text: 'Nice to have' },
  {
    type: 'bullets',
    items: ['Rich paste from Notion', 'Offline draft recovery'],
  },
]
